import { format } from 'date-fns';

export function toDateKey(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

// Constrói a data no fuso local a partir de 'yyyy-MM-dd'. `new Date('2026-08-20')`
// seria interpretado como UTC e voltaria um dia em fusos negativos (o caso do Brasil).
export function parseDateKey(dateKey: string): Date {
  const [year, month, day] = dateKey.split('-').map(Number);
  return new Date(year, (month || 1) - 1, day || 1);
}
